import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'gatsby'

import CarouselBanner from '@components/Home/Carousel/CarouselBanner'
import JustInSection from '@components/Home/JustInSection'
import LookBooksSection from '@components/Home/LookBooksSection'
//import FeaturedSection from '@components/Home/FeaturedSection'
import CollectionSection from '@components/Home/CollectionSection'
import DiscoverSection from '@components/Home/DiscoverSection'
import SuitYourselfSection from '@components/Home/SuitYourself/SuitYourselfSection'
import DisplayCard from '@components/productcards/DisplayCard'
import QuickBuyModal from '@components/modal/QuickBuyModal'
import QuickBuyContext from '@context/QuickBuyContext'

// assets

import bannerIslandLife from '@images/Home/banners/island-life-desktop.webp'
import mobilebannerIslandLife from '@images/Home/banners/island-life-mobile.webp'

import bannerPalacio from '@images/Home/banners/Homepage-Banner-Desktop-Week-2.webp'
import mobileBannerPalacio from '@images/Home/banners/Homepage-Banner-Mobile-Week-2.webp'
import bannerRedhot from '@images/Home/banners/Red-Hot-Gloss-Homepage-Banner-Desktop-W1.webp'
import mobileBannerRedhot from '@images/Home/banners/Red-Hot-Gloss-Homepage-Banner-Mobile-W1.webp'

import bannerButter from '@images/Home/banners/butter-yellow-banner-desktop.webp'
import mobileBannerButter from '@images/Home/banners/butter-yellow-banner-mobile.webp'

import bannerWish from '@images/Home/banners/wish-you-were-here-desktop.webp'
import mobileBannerWish from '@images/Home/banners/wish-you-were-here-mobile.webp'

import bannerSun from '@images/Home/banners/sunsoaked-banner-desktop.webp'
import mobileBannerSun from '@images/Home/banners/sunsoaked-banner-mobile.webp'

// sub banners
import subIslandLifeBanner from '@images/Home/sub-banners/island-life-desktop.webp'
import mobileIslandLifeSubBanner from '@images/Home/sub-banners/island-life-mobile.webp'

import bannerCaramel from '@images/Home/banners/caramel-eyelet-banner-desktop.webp'
import mobileBannerCaramel from '@images/Home/banners/caramel-eyelet-banner-mobile.webp'

// secondary banner
import secButterBanner from '@images/Home/secondary-banners/butter-banner.webp'

import shopTankinis from '@images/Home/shop-card-section/tankinis.webp'
import shopTextured from '@images/Home/shop-card-section/textured.webp'
import shopShorts from '@images/Home/shop-card-section/shop-shorts.jpg'
import shopSale from '@images/Home/shop-card-section/shop-sale.webp'
import UseWindowSize from '@components/helpers/UseWindowSize'

const HomePage = ({justIn, bestSellerCollection, homeCollection, featuredCollections}) => {
  const {
    quickBuyData,
    setQuickBuyData,
    addToBagClicked,
    setAddToBagClicked,
    isAddToCart,
    setIsAddToCart,
  } = useContext(QuickBuyContext)

    const { isMobile } = UseWindowSize()
  
	const [openQuickBuyModal, setOpenQuickBuyModal] = useState(false)
	const [product, setProduct] =  useState(null)
    const [hasMounted, setHasMounted] = useState(false);


    const videoBanner = "https://cdn.shopify.com/videos/c/o/v/1e4383c0c5ec4a82aae798f6aab18c86.mp4";
    const mobileVideoBanner = "https://cdn.shopify.com/videos/c/o/v/ad8bc1be0d4a45d883a20115f446586b.mp4"
    const videoRef = React.useRef(null);

	useEffect(() => {
		if(quickBuyData)
			setOpenQuickBuyModal(true)
			setProduct(quickBuyData)
			setIsAddToCart(false)
	}, [quickBuyData])

	useEffect(() => {
		if(addToBagClicked)
			setOpenQuickBuyModal(true)
			setProduct(addToBagClicked)
			setIsAddToCart(true)
	}, [addToBagClicked])

    useEffect(() => {
        setHasMounted(true);
    }, []);


	return (
		<React.Fragment>
			<CarouselBanner
				data={ process.env.GATSBY_STORE !== "PH" ? [
					/*
					#########################################################
					################### GLOBAL BANNERS ######################
					#########################################################
					*/
                    , 
                    {   
						title: "Caramel Eyelet", 
						image: bannerCaramel, 
						mobileImage: mobileBannerCaramel, 
						url: '/collections/all', 
						imageOnly: true,
						altText: 'Caramel Eyelet',
					},
                    {   
						title: "Island Life", 
						image: bannerIslandLife, 
						mobileImage: mobilebannerIslandLife, 
						url: '/collections/the-ashley-kelly-edit-island-life', 
						imageOnly: true,
						altText: 'Island Life',
					},
                    {   
						title: "Suns Soaked", 
						image: bannerSun, 
						mobileImage: mobileBannerSun, 
						url: '/collections/the-sunsoaked-collection/', 
						imageOnly: true,
						altText: 'Suns Soaked',
					},
                    {   
						title: "Butter Yellow", 
						image: bannerButter, 
						mobileImage: mobileBannerButter, 
						url: '/collections/the-butter-yellow-collection/',
						imageOnly: true,
						altText: 'Butter Yellow',
					},
                    {   
						title: "Wish you were here", 
						image: bannerWish, 
						mobileImage: mobileBannerWish, 
						url: '/collections/the-wish-you-were-here-collection', 
						imageOnly: true,
						altText: 'Wish you were here',
					},
                    /*,
                    {   
						title: "Red Hot Gloss", 
						image: bannerRedhot, 
						mobileImage: mobileBannerRedhot, 
						url: '/collections/the-red-hot-gloss-collection', 
						imageOnly: true,
						altText: 'Turn up the heat this summer',
					}
                    
					{   
						title: "Palacio Del Sol", 
						image: bannerPalacio, 
						mobileImage: mobileBannerPalacio, 
						url: '/collections/the-palacio-del-sol-collection', 
						imageOnly: true,
						altText: 'Wherever the sun takes you',
					}*/
					
					
				] : [
					/*
					#########################################################
					##################### PH BANNERS ########################
					#########################################################
					*/
                    {   
						title: "Caramel Eyelet", 
						image: bannerCaramel, 
						mobileImage: mobileBannerCaramel, 
						url: '/collections/all', 
						imageOnly: true,
						altText: 'Caramel Eyelet',
					},
                    {   
						title: "Island Life", 
						image: bannerIslandLife, 
						mobileImage: mobilebannerIslandLife, 
						url: '/collections/the-ashley-kelly-edit-island-life', 
						imageOnly: true,
						altText: 'Island Life',
					},
                    {   
						title: "Suns Soaked", 
						image: bannerSun, 
						mobileImage: mobileBannerSun, 
						url: '/collections/the-sunsoaked-collection/', 
						imageOnly: true,
						altText: 'Suns Soaked',
					},
                    {   
						title: "Butter Yellow", 
						image: bannerButter, 
						mobileImage: mobileBannerButter, 
						url: '/collections/the-butter-yellow-collection/', 
						imageOnly: true,
						altText: 'Butter Yellow',
					},
                    {   
						title: "Wish you were here", 
						image: bannerWish, 
						mobileImage: mobileBannerWish, 
						url: '/collections/the-wish-you-were-here-collection', 
						imageOnly: true,
						altText: 'Wish you were here',
					},
                    /*,
                    {   
						title: "Red Hot Gloss", 
						image: bannerRedhot, 
						mobileImage: mobileBannerRedhot, 
						url: '/collections/the-red-hot-gloss-collection', 
						imageOnly: true,
						altText: 'Turn up the heat this summer',
					}
                    
					{   
						title: "Palacio Del Sol", 
						image: bannerPalacio, 
						mobileImage: mobileBannerPalacio, 
						url: '/collections/the-palacio-del-sol-collection', 
						imageOnly: true,
						altText: 'Wherever the sun takes you',
					}
                    */
				]}
			/>

			<div className="px-4">
				<JustInSection justIn={justIn} bestSellerCollection={bestSellerCollection} />

					<div className='py-6 min-h-[400px] md:min-h-72 xl:min-h-[500px] w-full max-container'>
						<Link to='/collections/the-ashley-kelly-edit-island-life'>
                            <video 
                                ref={videoRef}
                                playsInline
                                muted
                                autoPlay
                                loop
                                preload="auto"
                                className={`w-full h-auto pointer-events-none mobile ${isMobile ? '' : 'hidden'}`} 
                                data-automation="VideoPlayer"
                                height="100%"
                                width="100%"
                                aria-label={`video-island-life`}
                                controlslist="nodownload"
                                onLoadedData={() => {
                                    videoRef.current?.play().catch(() => {});
                                }}
                            >
                                <source src={mobileVideoBanner} type="video/mp4" />
                            </video>  

                            <video 
                                playsInline
                                muted
                                autoPlay
                                loop
                                preload="auto"
                                className={`w-full h-auto pointer-events-none mobile ${isMobile ? 'hidden' : ''}`} 
                                data-automation="VideoPlayer"
                                height="100%"
                                width="100%"
                                aria-label={`video-island-life`}
                                controlslist="nodownload"
                            >
                                <source src={videoBanner} type="video/webm" />
                                <source src={videoBanner} type="video/mp4" />
                            </video>
						</Link>
					</div>

				<div className='py-6 w-full max-container'>
					{process.env.GATSBY_STORE === "PH" ? (
                        <Link to='/collections/the-ashley-kelly-edit-island-life'>
							<img className='w-full hidden md:block' src={`${subIslandLifeBanner}`} alt='Island Life' loading='lazy' />
							<img className='w-full block md:hidden' src={`${mobileIslandLifeSubBanner}`} alt='Island Life' loading='lazy' />
						</Link>
					) : (
						<Link to='/collections/the-ashley-kelly-edit-island-life'>
							<img className='w-full hidden md:block' src={`${subIslandLifeBanner}`} alt='Island Life' loading='lazy' />
							<img className='w-full block md:hidden' src={`${mobileIslandLifeSubBanner}`} alt='Island Life' loading='lazy' />
						</Link>
					)}
				</div>

                {
                    /*
                
				<section className="max-container mt-8 grid grid-cols-4 justify-between gap-4 xl:px-0">
					<DisplayCard
						data={{
							image: shopTankinis,
							description:
							`The perfect mix of cute and sexy. They don’t call it "tankini summer" for no reason.`,
							buttonLabel: "SHOP TANKINIS",
							title: "shop-tankinis",
							handle: "tankinis",
						}}
						cardStyles={'displaycard-default w-auto md:max-w-[340px] col-span-2 lg:col-span-1 flex flex-col justify-between mx-auto'}
						imageClass={'h-full w-full max-h-[160px] md:max-h-none md:w-auto md:h-[350px] lg:h-[240px] xl:h-[350px] object-cover'}
						ariaLabel={'SHOP TANKINIS'}
					/>

					<DisplayCard
						data={{
							image: shopTextured,
							description:
							"From pointelle to jacquards, and smocked to shimmers, your favorite textured bikinis are right at your fingertips.",
							buttonLabel: "SHOP TEXTURED SWIM",
							title: "shop-textured-swim",
							handle: "the-textured-collection",
						}}
						cardStyles={'displaycard-default w-auto md:max-w-[340px] col-span-2 lg:col-span-1 flex flex-col justify-between mx-auto'}
						imageClass={'h-[160px] w-full md:w-auto md:h-[350px] lg:h-[240px] xl:h-[350px] object-cover'}
						ariaLabel={'SHOP TEXTURED SWIM'}
					/>

					<DisplayCard
						data={{
							image: shopShorts,
							description:
							"Our best kept secret: ultra-comfy swim shorts. Made with durable mesh fabric, they might even be better than our bikinis. You heard it first here.",
							buttonLabel: "SHOP SWIM SHORTS",
							title: "shop-swim-shorts",
							handle: "swim-shorts",
						}}
						cardStyles={'displaycard-default w-auto md:max-w-[340px] col-span-2 lg:col-span-1 flex flex-col justify-between mx-auto'}
						imageClass={'h-[160px] w-full md:w-auto md:h-[350px] lg:h-[240px] xl:h-[350px] object-cover'}
						ariaLabel={'SHOP SWIM SHORTS'}
					/>

					<DisplayCard
						data={{
							image: shopSale,
							description: <>
							SALE MARKDOWNS<br />Your favorite swim styles for less.
							</>,
							buttonLabel: "SHOP UP TO 30% OFF",
							title: "shop-sale",
							handle: "sale",
						}}
						cardStyles={'displaycard-default w-auto md:max-w-[340px] col-span-2 lg:col-span-1 flex flex-col justify-between mx-auto'}
						imageClass={'h-[160px] w-full md:w-auto md:h-[350px] lg:h-[240px] xl:h-[350px] object-cover'}
						ariaLabel={'SHOP UP TO 30% OFF'}
					/>
				</section>
                    */
                }

				{/*<FeaturedSection homeCollection={homeCollection} />*/}
				<CollectionSection featuredCollections={featuredCollections} />
				<LookBooksSection data={{}} />
				<DiscoverSection data={{}} />
				<SuitYourselfSection hideHeader />
			</div>

			<QuickBuyModal 
				isOpen={openQuickBuyModal}
				onClose={() => {
					setQuickBuyData(null)
					setOpenQuickBuyModal(false)
					setAddToBagClicked(null)
					setIsAddToCart(false)
				}}
				data={product}
				isAddToCart={isAddToCart}
			/> 


			{/* <div className="hidden lg:block">
			<img className="w-100 h-auto" src={imgSuitYourself} alt='suit yourself' />
			</div> */}
		</React.Fragment>
	);
}

export default HomePage